import * as angular from "angular";
import {GlobalSearchItemsType} from "../types/global-search-items.type";
import * as _ from "lodash";
import {GlobalSearchEntity} from "../models/global-search-entity.model";
import {TaskModel} from "../../tasks/models/task.model";
import {FulfillmentStepModel} from "../../fulfillment/models/fulfillment-step.model";

export class GlobalSearchService {

  /* @ngInject */
  constructor() {
  }

  itemToItemOfType(items, type: GlobalSearchItemsType): GlobalSearchEntity[] {

    switch (type) {
      case GlobalSearchItemsType.Services: {
        return _.map(items, (delivery) => {
          return {
            id: delivery.id,
            agent: delivery.agent,
            externalId: delivery.externalId,
            orderId: delivery.orderId,
            orderExternalId: delivery.orderExternalId,
            notAfter: delivery.notAfter,
            notBefore: delivery.notBefore,
            pricePlanName: delivery.pricePlanName,
            proNumberList: delivery.proNumber ? [delivery.proNumber] : undefined,
            routeId: delivery.routeId,
            routeReference: delivery.routeReference,
            status: delivery.status,
            serviceType: delivery.serviceType,
            taskList: _.map(delivery.taskList, (task: TaskModel) => {
              return {
                purpose: task.taskSpec.purpose,
                address: task.taskSpec.address,
                contactName: task.taskSpec.contact.fullName,
                contactPhone: task.taskSpec.contact.phoneNo
              }
            })
          }
        })
      }

      case GlobalSearchItemsType.Orders: {
        return _.map(items, (order) => {
          return {
            id: order.id,
            externalId: order.externalId,
            proNumberList: _.get(order.fulfillmentLines[0], 'proNumber') ? [_.get(order.fulfillmentLines[0], 'proNumber')] : undefined,
            notBefore: _.get(order.fulfillmentLines[0], 'pickupTask.notBefore'),
            notAfter: _.get(order.fulfillmentLines[0], 'destinationTask.notAfter'),
            pricePlanName: _.get(order.fulfillmentLines[0], 'programName'),
            status: order.status,
            taskList: [{
              purpose: _.get(order.fulfillmentLines[0], 'pickupTask.purpose'),
              address: _.get(order.fulfillmentLines[0], 'pickupTask.location.address'),
              contactName: _.get(order.fulfillmentLines[0], 'pickupTask.contact.fullName'),
              contactPhone: _.get(order.fulfillmentLines[0], 'pickupTask.contact.phoneNo')
            },
              {
                purpose: _.get(order.fulfillmentLines[0], 'destinationTask.purpose'),
                address: _.get(order.fulfillmentLines[0], 'destinationTask.location.address'),
                contactName: _.get(order.fulfillmentLines[0], 'destinationTask.contact.fullName'),
                contactPhone: _.get(order.fulfillmentLines[0], 'destinationTask.contact.phoneNo')

              }]
          }
        })
      }

      case GlobalSearchItemsType.Attempts: {
        const modifiedSteps = _.map(items, (item) => {
          item.attempts?.forEach((a) => {
            _.set(a, 'step', item);
            _.set(a, 'orderId', item.orderId);
            _.set(a, 'orderExternalId', item.orderExternalId);
          })
          return item;
        })
        const attempts = _.flatMap(modifiedSteps, 'attempts');
        return _.map(attempts, (a: any) => {
          return {
            id: a.referenceId,
            agent: a.agent,
            externalId: a.externalId,
            notBefore: _.get(a, 'serviceAttemptInfo.notBefore'),
            notAfter: _.get(a, 'serviceAttemptInfo.notAfter'),
            pricePlanName: _.get(a, 'step.programType'),
            status: a.status,
            serviceType: a.type,
            orderId: a.orderId,
            orderExternalId: a.orderExternalId,
            subType: a.subType,
            taskList: _.get(a, 'serviceAttemptInfo.pickupTaskInfo') ?
              [
                {
                  address: _.get(a, 'step.pickup.location.address'),
                  contactName: _.get(a, 'step.pickup.contact.fullName'),
                  contactPhone: _.get(a, 'step.pickup.contact.phoneNo')
                },
                {
                  address: _.get(a, 'step.destination.location.address'),
                  contactName: _.get(a, 'step.destination.contact.fullName'),
                  contactPhone: _.get(a, 'step.destination.contact.phoneNo')
                }
              ] :
              [
                {
                  address: _.get(a, 'step.destination.location.address'),
                  contactName: _.get(a, 'step.destination.contact.fullName'),
                  contactPhone: _.get(a, 'step.destination.contact.phoneNo')
                }
              ]
            // taskList: _.map(a.taskList, (task: TaskModel) => {
            //   return {
            //     purpose: _.get(a, 'serviceAttemptInfo.notAfter'),
            //     address: task.taskSpec.address,
            //     contactName: task.taskSpec.contact.fullName,
            //     contactPhone: task.taskSpec.contact.phoneNo
            //   }
            // })
          }

        })
      }
    }
  }
}


angular
  .module('bringoz.admin.search')
  .service('globalSearchService', GlobalSearchService);
